import { useLocation } from 'quartz-routing/react-router';
import { useLayoutEffect } from 'react';
import { scrollPageToTop } from '../../utils/scrolling';
const ReactRouterScrollToTop = () => {
  const {
    pathname
  } = useLocation();
  useLayoutEffect(() => {
    scrollPageToTop();
  }, [pathname]);
  return null;
};
export default ReactRouterScrollToTop;